import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStylesItemPublish = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flexGrow: 1,
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
}));

ItemPublish.propTypes = {
  small: PropTypes.bool,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
};

export default function ItemPublish({small, data}) {
  const classes = useStylesItemPublish({small});

  return (
    <div className={classes.root}>
      <img
        src={data.image}
        alt={data.name}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src =
            'https://estrategia-web.s3.amazonaws.com/products/notfound.png';
        }}
      />
    </div>
  );
}
